<div class="griha-project-detail-header__wrapper" [class.schedule-only]="scheduleOnly">
  @if (scheduleOnly) {
    <div class="griha-project-detail-header__wrapper__icons">
      <div class="icons">
        @if (button == 'workshop') {
          @if (userRole !== 'Evaluator') {
            <button
              class="project-detail-header--btn_workshop"
              [ngClass]="isDisabled ? 'project-detail-header--btn_workshop_disabled' : ''"
              [disabled]="isDisabled"
              (click)="onWorkshopSchedule('workshop')"
            >
              <div class="project-detail-header--btn_workshop__section">
                <span class="project-detail-header--btn_workshop__section---text">{{ ctaLabel }}</span>
              </div>
            </button>
          }
        }
        @if (button == 'optional') {
          @if (userRole !== 'Evaluator') {
            <button
              class="project-detail-header--btn_workshop"
              [ngClass]="isDisabled ? 'project-detail-header--btn_workshop_disabled' : ''"
              [disabled]="isDisabled"
              (click)="onWorkshopSchedule('siteVisit')"
            >
              <div class="project-detail-header--btn_workshop__section">
                <span class="project-detail-header--btn_workshop__section---text">{{ ctaLabel }}</span>
              </div>
            </button>
          }
        }
        @if (button == 'mandatory') {
          @if (userRole !== 'Evaluator') {
            <button
              class="project-detail-header--btn_workshop"
              [matTooltip]="
                projectDetails?.submission_status === variableConstantFile.PROJECT_PENDING_SUBMISSION
                  ? 'Mandatory Sitevisit can be scheduled once project submitted'
                  : ''
              "
              [ngClass]="{
                'project-detail-header--btn_workshop_disabled':
                  isDisabled ||
                  projectDetails?.submission_status ===
                    variableConstantFile.PROJECT_PENDING_SUBMISSION
              }"
              [disabled]="
                projectDetails?.submission_status ===
                  variableConstantFile.PROJECT_PENDING_SUBMISSION || isDisabled
              "
              (click)="onWorkshopSchedule('mandatory_siteVisit')"
            >
              <div class="project-detail-header--btn_workshop__section">
                <span class="project-detail-header--btn_workshop__section---text">{{ ctaLabel }}</span>
              </div>
            </button>
          }
        }
      </div>
    </div>
  } @else {
    <div class="griha-project-detail-header__wrapper__icons">
      <div>
        <div class="timeline-container">
          @for (step of steps; track step) {
            <div class="arrow-box">
              <div class="upper-box" [ngStyle]="{'background-color': step.date != '' ? step.color : '#D9D9D9'}">
                {{ step.title }}
                @if (step.date) {
                  <span>{{ formatDateWithComma(step.date) }}</span>
                }
                <div class="line" [ngStyle]="{'background-color': step.date != '' ? step.color : '#D9D9D9'}"></div>
              </div>
              <div class="arrow" [ngStyle]="{'background-color': step.date != '' ? '#2e2d72' : '#D9D9D9'}">
                <svg class="dot" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="none" [attr.stroke]="step.date != '' ? step.color : '#D9D9D9'"
                    stroke-width="2" />
                  <circle cx="12" cy="12" r="8" fill="white" />
                </svg>
              </div>
              @if (step.title == 'Workshop Optional') {
                @if (userRole !== 'Evaluator') {
                  <button
                    type="button"
                    class="schedule-button"
                    matTooltip="Go to Workshop & Site Visit"
                    (click)="onWorkshopSchedule('workshop')"
                  >
                    <img src="/assets/images/calendar_black.svg" alt="Schedule workshop" />
                  </button>
                }
              } @else if (step.title == 'Site-visit (Optional)') {
                @if (userRole !== 'Evaluator') {
                  <button
                    type="button"
                    class="schedule-button"
                    matTooltip="Go to Optional Site Visit"
                    (click)="onWorkshopSchedule('siteVisit')"
                  >
                    <img src="/assets/images/calendar_black.svg" alt="Schedule optional site visit" />
                  </button>
                }
              } @else if (step.title == 'Site-visit (Mandatory)') {
                @if (userRole !== 'Evaluator') {
                  <button
                    type="button"
                    class="schedule-button"
                    [disabled]="
                      projectDetails?.submission_status ===
                        variableConstantFile.PROJECT_PENDING_SUBMISSION &&
                      userRole === 'Client'
                    "
                    [matTooltip]="
                      projectDetails?.submission_status ===
                        variableConstantFile.PROJECT_PENDING_SUBMISSION &&
                      userRole === 'Client'
                        ? 'Mandatory Sitevisit can be scheduled once project submitted'
                        : 'Go to Final Site Visit'
                    "
                    (click)="onWorkshopSchedule('mandatory_siteVisit')"
                  >
                    <img src="/assets/images/calendar_black.svg" alt="Schedule mandatory site visit" />
                  </button>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
